module.exports = __webpack_public_path__ + "img/like-icon.12b55913.svg";